import React from 'react'

const Ride = () => {
  return (
    <div>
      abcd
    </div>
  )
}

export default Ride
